import { render, staticRenderFns } from "./pcDialog.vue?vue&type=template&id=5a052ef8&scoped=true"
import script from "./pcDialog.vue?vue&type=script&lang=js"
export * from "./pcDialog.vue?vue&type=script&lang=js"
import style0 from "./pcDialog.vue?vue&type=style&index=0&id=5a052ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a052ef8",
  null
  
)

export default component.exports